

const OverlayLoader = () => {
    return (
        <div className="loader-overlay"></div>
    );
}
export default OverlayLoader;